// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AppRouteImport } from './routes/app'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as DashboardTourRouteImport } from './routes/dashboard-tour'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as StackRouteImport } from './routes/stack'
import { Route as UseCasesRouteImport } from './routes/use-cases'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAgentsRouteImport } from './routes/app/agents'
import { Route as AppAnalyticsRouteImport } from './routes/app/analytics'
import { Route as AppApiKeysRouteImport } from './routes/app/api-keys'
import { Route as AppApprovalsRouteImport } from './routes/app/approvals'
import { Route as AppInboundRouteImport } from './routes/app/inbound'
import { Route as AppLogsRouteImport } from './routes/app/logs'
import { Route as AppMailRouteImport } from './routes/app/mail'
import { Route as AppMailboxesRouteImport } from './routes/app/mailboxes'
import { Route as AppPlacementRouteImport } from './routes/app/placement'
import { Route as AppPreferencesRouteImport } from './routes/app/preferences'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppSuppressionsRouteImport } from './routes/app/suppressions'
import { Route as AppTeamRouteImport } from './routes/app/team'
import { Route as GuidesIndexRouteImport } from './routes/guides/index'
import { Route as GuidesApiKeysAndEnvironmentsRouteImport } from './routes/guides/api-keys-and-environments'
import { Route as GuidesAutomationsInstanceVsCohortRouteImport } from './routes/guides/automations-instance-vs-cohort'
import { Route as GuidesBatchAndScheduleRouteImport } from './routes/guides/batch-and-schedule'
import { Route as GuidesBroadcastsAtScaleRouteImport } from './routes/guides/broadcasts-at-scale'
import { Route as GuidesChooseASendingTransportRouteImport } from './routes/guides/choose-a-sending-transport'
import { Route as GuidesClaimYourInstanceRouteImport } from './routes/guides/claim-your-instance'
import { Route as GuidesDebugA550RejectionRouteImport } from './routes/guides/debug-a-550-rejection'
import { Route as GuidesDeployToCloudflareRouteImport } from './routes/guides/deploy-to-cloudflare'
import { Route as GuidesDmarcFromNoneToRejectRouteImport } from './routes/guides/dmarc-from-none-to-reject'
import { Route as GuidesInboxPlacementVsDeliveryRouteImport } from './routes/guides/inbox-placement-vs-delivery'
import { Route as GuidesMcpAgentInboxRouteImport } from './routes/guides/mcp-agent-inbox'
import { Route as GuidesMigrateFromResendRouteImport } from './routes/guides/migrate-from-resend'
import { Route as GuidesOpenRatesAndAppleMppRouteImport } from './routes/guides/open-rates-and-apple-mpp'
import { Route as GuidesReadABounceRouteImport } from './routes/guides/read-a-bounce'
import { Route as GuidesReceiveEmailRouteImport } from './routes/guides/receive-email'
import { Route as GuidesSegmentsQueryLanguageRouteImport } from './routes/guides/segments-query-language'
import { Route as GuidesSelfHostOnANodeServerRouteImport } from './routes/guides/self-host-on-a-node-server'
import { Route as GuidesSendYourFirstEmailRouteImport } from './routes/guides/send-your-first-email'
import { Route as GuidesSpfDkimDmarcRouteImport } from './routes/guides/spf-dkim-dmarc'
import { Route as GuidesTemplatesHandlebarsMjmlRouteImport } from './routes/guides/templates-handlebars-mjml'
import { Route as GuidesUnsubscribeAndPreferencesRouteImport } from './routes/guides/unsubscribe-and-preferences'
import { Route as GuidesVerifyASendingDomainRouteImport } from './routes/guides/verify-a-sending-domain'
import { Route as GuidesWarmUpASendingDomainRouteImport } from './routes/guides/warm-up-a-sending-domain'
import { Route as GuidesWebhooksEndToEndRouteImport } from './routes/guides/webhooks-end-to-end'
import { Route as GuidesWhat100kEmailsCostsRouteImport } from './routes/guides/what-100k-emails-costs'
import { Route as GuidesWhyEmailGoesToSpamRouteImport } from './routes/guides/why-email-goes-to-spam'
import { Route as LegalDpaRouteImport } from './routes/legal/dpa'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as AppAudiencesIndexRouteImport } from './routes/app/audiences.index'
import { Route as AppAudiencesAudienceIdRouteImport } from './routes/app/audiences.$audienceId'
import { Route as AppAutomationsIndexRouteImport } from './routes/app/automations.index'
import { Route as AppAutomationsAutomationIdRouteImport } from './routes/app/automations.$automationId'
import { Route as AppBroadcastsIndexRouteImport } from './routes/app/broadcasts.index'
import { Route as AppBroadcastsBroadcastIdRouteImport } from './routes/app/broadcasts.$broadcastId'
import { Route as AppBroadcastsNewRouteImport } from './routes/app/broadcasts.new'
import { Route as AppDomainsIndexRouteImport } from './routes/app/domains.index'
import { Route as AppDomainsDomainIdRouteImport } from './routes/app/domains.$domainId'
import { Route as AppEmailsEmailIdRouteImport } from './routes/app/emails.$emailId'
import { Route as AppSegmentsIndexRouteImport } from './routes/app/segments.index'
import { Route as AppSegmentsSegmentIdRouteImport } from './routes/app/segments.$segmentId'
import { Route as AppTemplatesIndexRouteImport } from './routes/app/templates.index'
import { Route as AppTemplatesTemplateIdRouteImport } from './routes/app/templates.$templateId'
import { Route as AppWebhooksIndexRouteImport } from './routes/app/webhooks.index'
import { Route as AppWebhooksWebhookIdRouteImport } from './routes/app/webhooks.$webhookId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const DashboardTourRoute = DashboardTourRouteImport.update({
            id: '/dashboard-tour',path: '/dashboard-tour',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const SetupRoute = SetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const StackRoute = StackRouteImport.update({
            id: '/stack',path: '/stack',getParentRoute: () => rootRouteImport
          })
const UseCasesRoute = UseCasesRouteImport.update({
            id: '/use-cases',path: '/use-cases',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppAgentsRoute = AppAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AppRoute
          })
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AppRoute
          })
const AppApiKeysRoute = AppApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AppRoute
          })
const AppApprovalsRoute = AppApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => AppRoute
          })
const AppInboundRoute = AppInboundRouteImport.update({
            id: '/inbound',path: '/inbound',getParentRoute: () => AppRoute
          })
const AppLogsRoute = AppLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => AppRoute
          })
const AppMailRoute = AppMailRouteImport.update({
            id: '/mail',path: '/mail',getParentRoute: () => AppRoute
          })
const AppMailboxesRoute = AppMailboxesRouteImport.update({
            id: '/mailboxes',path: '/mailboxes',getParentRoute: () => AppRoute
          })
const AppPlacementRoute = AppPlacementRouteImport.update({
            id: '/placement',path: '/placement',getParentRoute: () => AppRoute
          })
const AppPreferencesRoute = AppPreferencesRouteImport.update({
            id: '/preferences',path: '/preferences',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppSuppressionsRoute = AppSuppressionsRouteImport.update({
            id: '/suppressions',path: '/suppressions',getParentRoute: () => AppRoute
          })
const AppTeamRoute = AppTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AppRoute
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesApiKeysAndEnvironmentsRoute = GuidesApiKeysAndEnvironmentsRouteImport.update({
            id: '/guides/api-keys-and-environments',path: '/guides/api-keys-and-environments',getParentRoute: () => rootRouteImport
          })
const GuidesAutomationsInstanceVsCohortRoute = GuidesAutomationsInstanceVsCohortRouteImport.update({
            id: '/guides/automations-instance-vs-cohort',path: '/guides/automations-instance-vs-cohort',getParentRoute: () => rootRouteImport
          })
const GuidesBatchAndScheduleRoute = GuidesBatchAndScheduleRouteImport.update({
            id: '/guides/batch-and-schedule',path: '/guides/batch-and-schedule',getParentRoute: () => rootRouteImport
          })
const GuidesBroadcastsAtScaleRoute = GuidesBroadcastsAtScaleRouteImport.update({
            id: '/guides/broadcasts-at-scale',path: '/guides/broadcasts-at-scale',getParentRoute: () => rootRouteImport
          })
const GuidesChooseASendingTransportRoute = GuidesChooseASendingTransportRouteImport.update({
            id: '/guides/choose-a-sending-transport',path: '/guides/choose-a-sending-transport',getParentRoute: () => rootRouteImport
          })
const GuidesClaimYourInstanceRoute = GuidesClaimYourInstanceRouteImport.update({
            id: '/guides/claim-your-instance',path: '/guides/claim-your-instance',getParentRoute: () => rootRouteImport
          })
const GuidesDebugA550RejectionRoute = GuidesDebugA550RejectionRouteImport.update({
            id: '/guides/debug-a-550-rejection',path: '/guides/debug-a-550-rejection',getParentRoute: () => rootRouteImport
          })
const GuidesDeployToCloudflareRoute = GuidesDeployToCloudflareRouteImport.update({
            id: '/guides/deploy-to-cloudflare',path: '/guides/deploy-to-cloudflare',getParentRoute: () => rootRouteImport
          })
const GuidesDmarcFromNoneToRejectRoute = GuidesDmarcFromNoneToRejectRouteImport.update({
            id: '/guides/dmarc-from-none-to-reject',path: '/guides/dmarc-from-none-to-reject',getParentRoute: () => rootRouteImport
          })
const GuidesInboxPlacementVsDeliveryRoute = GuidesInboxPlacementVsDeliveryRouteImport.update({
            id: '/guides/inbox-placement-vs-delivery',path: '/guides/inbox-placement-vs-delivery',getParentRoute: () => rootRouteImport
          })
const GuidesMcpAgentInboxRoute = GuidesMcpAgentInboxRouteImport.update({
            id: '/guides/mcp-agent-inbox',path: '/guides/mcp-agent-inbox',getParentRoute: () => rootRouteImport
          })
const GuidesMigrateFromResendRoute = GuidesMigrateFromResendRouteImport.update({
            id: '/guides/migrate-from-resend',path: '/guides/migrate-from-resend',getParentRoute: () => rootRouteImport
          })
const GuidesOpenRatesAndAppleMppRoute = GuidesOpenRatesAndAppleMppRouteImport.update({
            id: '/guides/open-rates-and-apple-mpp',path: '/guides/open-rates-and-apple-mpp',getParentRoute: () => rootRouteImport
          })
const GuidesReadABounceRoute = GuidesReadABounceRouteImport.update({
            id: '/guides/read-a-bounce',path: '/guides/read-a-bounce',getParentRoute: () => rootRouteImport
          })
const GuidesReceiveEmailRoute = GuidesReceiveEmailRouteImport.update({
            id: '/guides/receive-email',path: '/guides/receive-email',getParentRoute: () => rootRouteImport
          })
const GuidesSegmentsQueryLanguageRoute = GuidesSegmentsQueryLanguageRouteImport.update({
            id: '/guides/segments-query-language',path: '/guides/segments-query-language',getParentRoute: () => rootRouteImport
          })
const GuidesSelfHostOnANodeServerRoute = GuidesSelfHostOnANodeServerRouteImport.update({
            id: '/guides/self-host-on-a-node-server',path: '/guides/self-host-on-a-node-server',getParentRoute: () => rootRouteImport
          })
const GuidesSendYourFirstEmailRoute = GuidesSendYourFirstEmailRouteImport.update({
            id: '/guides/send-your-first-email',path: '/guides/send-your-first-email',getParentRoute: () => rootRouteImport
          })
const GuidesSpfDkimDmarcRoute = GuidesSpfDkimDmarcRouteImport.update({
            id: '/guides/spf-dkim-dmarc',path: '/guides/spf-dkim-dmarc',getParentRoute: () => rootRouteImport
          })
const GuidesTemplatesHandlebarsMjmlRoute = GuidesTemplatesHandlebarsMjmlRouteImport.update({
            id: '/guides/templates-handlebars-mjml',path: '/guides/templates-handlebars-mjml',getParentRoute: () => rootRouteImport
          })
const GuidesUnsubscribeAndPreferencesRoute = GuidesUnsubscribeAndPreferencesRouteImport.update({
            id: '/guides/unsubscribe-and-preferences',path: '/guides/unsubscribe-and-preferences',getParentRoute: () => rootRouteImport
          })
const GuidesVerifyASendingDomainRoute = GuidesVerifyASendingDomainRouteImport.update({
            id: '/guides/verify-a-sending-domain',path: '/guides/verify-a-sending-domain',getParentRoute: () => rootRouteImport
          })
const GuidesWarmUpASendingDomainRoute = GuidesWarmUpASendingDomainRouteImport.update({
            id: '/guides/warm-up-a-sending-domain',path: '/guides/warm-up-a-sending-domain',getParentRoute: () => rootRouteImport
          })
const GuidesWebhooksEndToEndRoute = GuidesWebhooksEndToEndRouteImport.update({
            id: '/guides/webhooks-end-to-end',path: '/guides/webhooks-end-to-end',getParentRoute: () => rootRouteImport
          })
const GuidesWhat100kEmailsCostsRoute = GuidesWhat100kEmailsCostsRouteImport.update({
            id: '/guides/what-100k-emails-costs',path: '/guides/what-100k-emails-costs',getParentRoute: () => rootRouteImport
          })
const GuidesWhyEmailGoesToSpamRoute = GuidesWhyEmailGoesToSpamRouteImport.update({
            id: '/guides/why-email-goes-to-spam',path: '/guides/why-email-goes-to-spam',getParentRoute: () => rootRouteImport
          })
const LegalDpaRoute = LegalDpaRouteImport.update({
            id: '/legal/dpa',path: '/legal/dpa',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const AppAudiencesIndexRoute = AppAudiencesIndexRouteImport.update({
            id: '/audiences/',path: '/audiences/',getParentRoute: () => AppRoute
          })
const AppAudiencesAudienceIdRoute = AppAudiencesAudienceIdRouteImport.update({
            id: '/audiences/$audienceId',path: '/audiences/$audienceId',getParentRoute: () => AppRoute
          })
const AppAutomationsIndexRoute = AppAutomationsIndexRouteImport.update({
            id: '/automations/',path: '/automations/',getParentRoute: () => AppRoute
          })
const AppAutomationsAutomationIdRoute = AppAutomationsAutomationIdRouteImport.update({
            id: '/automations/$automationId',path: '/automations/$automationId',getParentRoute: () => AppRoute
          })
const AppBroadcastsIndexRoute = AppBroadcastsIndexRouteImport.update({
            id: '/broadcasts/',path: '/broadcasts/',getParentRoute: () => AppRoute
          })
const AppBroadcastsBroadcastIdRoute = AppBroadcastsBroadcastIdRouteImport.update({
            id: '/broadcasts/$broadcastId',path: '/broadcasts/$broadcastId',getParentRoute: () => AppRoute
          })
const AppBroadcastsNewRoute = AppBroadcastsNewRouteImport.update({
            id: '/broadcasts/new',path: '/broadcasts/new',getParentRoute: () => AppRoute
          })
const AppDomainsIndexRoute = AppDomainsIndexRouteImport.update({
            id: '/domains/',path: '/domains/',getParentRoute: () => AppRoute
          })
const AppDomainsDomainIdRoute = AppDomainsDomainIdRouteImport.update({
            id: '/domains/$domainId',path: '/domains/$domainId',getParentRoute: () => AppRoute
          })
const AppEmailsEmailIdRoute = AppEmailsEmailIdRouteImport.update({
            id: '/emails/$emailId',path: '/emails/$emailId',getParentRoute: () => AppRoute
          })
const AppSegmentsIndexRoute = AppSegmentsIndexRouteImport.update({
            id: '/segments/',path: '/segments/',getParentRoute: () => AppRoute
          })
const AppSegmentsSegmentIdRoute = AppSegmentsSegmentIdRouteImport.update({
            id: '/segments/$segmentId',path: '/segments/$segmentId',getParentRoute: () => AppRoute
          })
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
            id: '/templates/',path: '/templates/',getParentRoute: () => AppRoute
          })
const AppTemplatesTemplateIdRoute = AppTemplatesTemplateIdRouteImport.update({
            id: '/templates/$templateId',path: '/templates/$templateId',getParentRoute: () => AppRoute
          })
const AppWebhooksIndexRoute = AppWebhooksIndexRouteImport.update({
            id: '/webhooks/',path: '/webhooks/',getParentRoute: () => AppRoute
          })
const AppWebhooksWebhookIdRoute = AppWebhooksWebhookIdRouteImport.update({
            id: '/webhooks/$webhookId',path: '/webhooks/$webhookId',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppAgentsRoute: AppAgentsRoute,AppAnalyticsRoute: AppAnalyticsRoute,AppApiKeysRoute: AppApiKeysRoute,AppApprovalsRoute: AppApprovalsRoute,AppInboundRoute: AppInboundRoute,AppLogsRoute: AppLogsRoute,AppMailRoute: AppMailRoute,AppMailboxesRoute: AppMailboxesRoute,AppPlacementRoute: AppPlacementRoute,AppPreferencesRoute: AppPreferencesRoute,AppSettingsRoute: AppSettingsRoute,AppSuppressionsRoute: AppSuppressionsRoute,AppTeamRoute: AppTeamRoute,AppIndexRoute: AppIndexRoute,AppAudiencesAudienceIdRoute: AppAudiencesAudienceIdRoute,AppAutomationsAutomationIdRoute: AppAutomationsAutomationIdRoute,AppBroadcastsBroadcastIdRoute: AppBroadcastsBroadcastIdRoute,AppBroadcastsNewRoute: AppBroadcastsNewRoute,AppDomainsDomainIdRoute: AppDomainsDomainIdRoute,AppEmailsEmailIdRoute: AppEmailsEmailIdRoute,AppSegmentsSegmentIdRoute: AppSegmentsSegmentIdRoute,AppTemplatesTemplateIdRoute: AppTemplatesTemplateIdRoute,AppWebhooksWebhookIdRoute: AppWebhooksWebhookIdRoute,AppAudiencesIndexRoute: AppAudiencesIndexRoute,AppAutomationsIndexRoute: AppAutomationsIndexRoute,AppBroadcastsIndexRoute: AppBroadcastsIndexRoute,AppDomainsIndexRoute: AppDomainsIndexRoute,AppSegmentsIndexRoute: AppSegmentsIndexRoute,AppTemplatesIndexRoute: AppTemplatesIndexRoute,AppWebhooksIndexRoute: AppWebhooksIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnalyticsRoute: AnalyticsRoute,AppRoute: AppRouteWithChildren,CompareRoute: CompareRoute,DashboardTourRoute: DashboardTourRoute,DemoRoute: DemoRoute,DocsRoute: DocsRoute,PricingRoute: PricingRoute,ResourcesRoute: ResourcesRoute,SetupRoute: SetupRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,StackRoute: StackRoute,UseCasesRoute: UseCasesRoute,GuidesApiKeysAndEnvironmentsRoute: GuidesApiKeysAndEnvironmentsRoute,GuidesAutomationsInstanceVsCohortRoute: GuidesAutomationsInstanceVsCohortRoute,GuidesBatchAndScheduleRoute: GuidesBatchAndScheduleRoute,GuidesBroadcastsAtScaleRoute: GuidesBroadcastsAtScaleRoute,GuidesChooseASendingTransportRoute: GuidesChooseASendingTransportRoute,GuidesClaimYourInstanceRoute: GuidesClaimYourInstanceRoute,GuidesDebugA550RejectionRoute: GuidesDebugA550RejectionRoute,GuidesDeployToCloudflareRoute: GuidesDeployToCloudflareRoute,GuidesDmarcFromNoneToRejectRoute: GuidesDmarcFromNoneToRejectRoute,GuidesInboxPlacementVsDeliveryRoute: GuidesInboxPlacementVsDeliveryRoute,GuidesMcpAgentInboxRoute: GuidesMcpAgentInboxRoute,GuidesMigrateFromResendRoute: GuidesMigrateFromResendRoute,GuidesOpenRatesAndAppleMppRoute: GuidesOpenRatesAndAppleMppRoute,GuidesReadABounceRoute: GuidesReadABounceRoute,GuidesReceiveEmailRoute: GuidesReceiveEmailRoute,GuidesSegmentsQueryLanguageRoute: GuidesSegmentsQueryLanguageRoute,GuidesSelfHostOnANodeServerRoute: GuidesSelfHostOnANodeServerRoute,GuidesSendYourFirstEmailRoute: GuidesSendYourFirstEmailRoute,GuidesSpfDkimDmarcRoute: GuidesSpfDkimDmarcRoute,GuidesTemplatesHandlebarsMjmlRoute: GuidesTemplatesHandlebarsMjmlRoute,GuidesUnsubscribeAndPreferencesRoute: GuidesUnsubscribeAndPreferencesRoute,GuidesVerifyASendingDomainRoute: GuidesVerifyASendingDomainRoute,GuidesWarmUpASendingDomainRoute: GuidesWarmUpASendingDomainRoute,GuidesWebhooksEndToEndRoute: GuidesWebhooksEndToEndRoute,GuidesWhat100kEmailsCostsRoute: GuidesWhat100kEmailsCostsRoute,GuidesWhyEmailGoesToSpamRoute: GuidesWhyEmailGoesToSpamRoute,LegalDpaRoute: LegalDpaRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,GuidesIndexRoute: GuidesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)